<template style='height：100%'>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="content">
          <div class="title">用户登录</div>
          <div class="form-box">
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/user.png')" alt="" />
              </div>
              <div class="list-right">
                <input
                  type="text"
                  v-model="form.username"
                  placeholder="用户名称"
                />
              </div>
            </div>
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/password.png')" alt="" />
              </div>
              <div class="list-right">
                <input
                  type="password"
                  v-model="form.password"
                  placeholder="请输入登录密码"
                />
              </div>
            </div>
            <div class="form-list">
              <div class="list-left">
                <img :src="require('@/assets/image/pin.png')" alt="" />
              </div>
              <div class="list-right">
                <input
                  class="code"
                  type="text"
                  v-model="form.code"
                  placeholder="输入验证码"
                />
                <el-image
                  :src="captchaImg"
                  class="captchaImg"
                  @click="getCaptcha"
                ></el-image>
              </div>
            </div>
          </div>
          <el-button class="login" type="warning" round @click="login(form)"
            >登录</el-button
          >
          <div class="register" @click='jump()'>新用户注册</div>
          <div class="left-pic">
          <img :src="require('@/assets/image/tree.png')" alt="" />
        </div>
        <div class="right-pic">
          <img :src="require('@/assets/image/people.png')" style='z-index:-1;' alt="" />
        </div>
        </div>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerList from "./public/header";
import qs from "qs";
export default {
  name: "webLogin",
  components: { headerList },
  data() {
    return {
      form: {
        username: "",
        password: "",
        code: "",
        token: "",
      },
      captchaImg: null,
    };
  },
  created() {
    this.getCaptcha();
  },
  methods: {
    onSubmit() {
    },
    getCaptcha() {
      this.$axios.get("/captcha").then((res) => {


        this.form.token = res.data.data.token;
        this.captchaImg = res.data.data.captchaImg;
        this.form.code = "";
      });
    },
    login(form) {
       if(form.username ==''){
          this.$message.error('请输入账号');
            return;
      }
       if(form.password ==''){
          this.$message.error('请输入密码');
            return;
      }
      if(form.code ==''){
          this.$message.error('请输入验证码');
            return;
      }
      this.$axios
        .post("/login?" + qs.stringify(form))
        .then((res) => {
          //  const jwt = res.headers["authorization"];
          //  this.$store.commit("SET_TOKEN", jwt);
          // return;
          if(res.status == 200){
            // localStorage.setItem("token",token)
            // alert(res.headers["authorization"])
            const jwt = res.headers["authorization"];
            this.$store.commit("SET_TOKEN", jwt);
            this.getUserInfo();

          }else{

          }

        })
        .catch((error) => {
           this.getCaptcha()
        });
    },
    getUserInfo(){
      this.$axios.get("gw/sys/userInfo").then((res) => {
        this.userInfo = res.data.data;
        // url= this.userInfo.param;
        localStorage.setItem("userInfo",JSON.stringify(this.userInfo));
         this.$router.push("/");
      });
    },
    jump(){
       this.$router.push("/registered");
    }
  },
};
</script>
<style scoped>
.box {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/image/background.jpg") no-repeat;
  background-size: 100% 100%;
}
.el-container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 115px !important;
  line-height: 115px;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  z-index: 99;
}
.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
.content {
  width: 795px;
  height: 665px;
  background: #fff;
  opacity: 0.7;
  margin: 131px auto;
  position: relative;
  top: 0;
  left: 0;
}
.left-pic {
  width: 141px;
  height: 227px;
  position: absolute;
  bottom: -50px;
  left: -50px;
}
.right-pic {
  width: 242px;
  height: 207px;
  position: absolute;
  bottom: -50px;
  right: -50px;
}
.title {
  width: 137px;
  height: 176px;
  margin: 0 auto;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #f78100;
  line-height: 176px;
}
a {
  text-decoration: none;
}
.form-box {
  width: 460px;
  height: 240px;
  margin: 0 auto;
}
.form-list {
  margin-top: 30px;
  height: 50px;
  border-bottom: 2px solid #c1b8af;
}
.list-left {
  float: left;
  width: 100px;
  height: 50px;
}
.list-left img {
  margin: 10px 35px;
}
.list-right {
  float: left;
  width: 360px;
}
.list-right input {
  border: none;
  height: 50px;
  font-size: 24px;
  width: 100%;
  outline: none;
  background: none;
}
.list-right .code {
  width: 60%;
}
.login {
  width: 460px;
  height: 60px;
  font-size: 24px;
  background: #e73e10;
  border-radius: 30px;
  margin: 0 167px;
}
.register {
  width: 80px;
  height: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f78100;
  margin: 10px 167px 10px 548px;
    cursor:pointer;
}
</style>
